import React, { useContext, useState } from "react";
import { Accordion, Form, Grid, Label, Table } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState } from "../State";
import { handleSubmit, store } from "../store";

const MembershipQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });

  const globalState = useContext(store);
    const { dispatch } = globalState;
    const panels = [
        {
            key: 'questions',
            title: {
                content: <Label size="huge" color="green">Click <u>here</u> to View Available Inquiry Related Documents</Label>,
                icon: <i className="invisible"></i>,
            },
            content: {
                content: (
                    <Table striped unstackable inverted={globalState.state.appState.isDarkTheme}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={8} textAlign="center">Inquiry Type</Table.HeaderCell>
                                <Table.HeaderCell width={8} textAlign="center">Document</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Contact Change</Table.Cell>
                                <Table.Cell><a className="color-green" href="https://www.njcrib.com/Search/ViewPDFByName?documentTitle=Carrier%20Contact%20Information%20Form%20(New%20Members)&share=Forms&extension=pdf">Carrier Contact Information Form</a></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Managed Care Program</Table.Cell>
                                <Table.Cell><a className="color-green" href="https://www.njcrib.com/Search/ViewPDFByName?documentTitle=Form%20Req%2011%206&share=Forms&extension=pdf">Application for An Approved Premium Reduction</a></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                ),
            },
        },
    ];

  return (
      <Grid centered className="QuestionSetContainer">
          <Grid.Row>
              <Label style={{ lineHeight: '20px' }} size={"big"}>Member carriers are insurance providers licensed to write<br />workers compensation in the state of New Jersey.<span style={{ color: 'orange' }}><br />This portal is not for agents, employers, or injured workers.</span><br /><i>Carriers, this portal is not for inquiries or compliance matters in regard to policies <u>issued</u> by your company.</i></Label>
          </Grid.Row>
          <Grid.Row>
              <Accordion panels={panels} />
          </Grid.Row>
          <Grid.Row>
              <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                  {
                      <QuestionSet isLoading={state.isLoading} icon={state.icon}
                          onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                              globalState.state, e, "HIP")}
                          questionAnswers={globalState.state.answerState!} />
                  }
              </Form>
          </Grid.Row>
      </Grid>
  );
};

export default MembershipQuestionnaire;
